export default __webpack_public_path__ + "static/media/back.7bf7a56f.svg";